<i18n lang="yaml">
  ru:
    ActionSidebarSettingsTriggers: "Список условий"
    ActionSidebarSettingsTriggersTimeout: "Время после загрузки страницы"
    ActionSidebarSettingsTriggersScroll: "Прокрутка страницы"
    ActionSidebarSettingsTriggersDevice: "Тип устройства"
    ActionSidebarSettingsTriggersUrl: "Адрес текущей страницы"
    ActionSidebarSettingsTriggersIncludes: "Содержит"
    ActionSidebarSettingsTriggersNotIncludes: "Не содержит"
    ActionSidebarSettingsTriggersEquals: "Равен"
    ActionSidebarSettingsTriggersNotEquals: "Не равен"
    ActionSidebarSettingsTriggersStartsWith: "Начинается с"
  en:
    ActionSidebarSettingsTriggers: "List of conditions"
    ActionSidebarSettingsTriggersTimeout: "Time after loading the page"
    ActionSidebarSettingsTriggersScroll: "Scrolling the page"
    ActionSidebarSettingsTriggersDevice: "Device"
    ActionSidebarSettingsTriggersUrl: "The address of the current page"
    ActionSidebarSettingsTriggersIncludes: "Contains"
    ActionSidebarSettingsTriggersNotIncludes: "Does not contain"
    ActionSidebarSettingsTriggersEquals: "Equal"
    ActionSidebarSettingsTriggersNotEquals: "Not equal"
    ActionSidebarSettingsTriggersStartsWith: "Begin with"
</i18n>

<template>
  <PWAsideBodyItem
    :title="$t('ActionSidebarSettingsTriggers')"
  >
    <div :class="$style.actionSidebarSettingsTriggers">
      <ActionSidebarSettingsTriggersItem
        type="timeout"
        :title="$t('ActionSidebarSettingsTriggersTimeout')"
        :enabled="afterPageLoadEnabledLocal"
        :value="afterPageLoadSecondsLocal"
        @update-enabled="afterPageLoadEnabledLocal = $event"
        @update-value="afterPageLoadSecondsLocal = $event"
      />

      <ActionSidebarSettingsTriggersItem
        type="scroll"
        :title="$t('ActionSidebarSettingsTriggersScroll')"
        :enabled="pageScrollBelowEnabledLocal"
        :value="pageScrollBelowAmountLocal"
        @update-enabled="pageScrollBelowEnabledLocal = $event"
        @update-value="pageScrollBelowAmountLocal = $event"
      />

      <ActionSidebarSettingsTriggersItem
        type="device"
        :title="$t('ActionSidebarSettingsTriggersDevice')"
        :enabled="deviceEnabledLocal"
        :value="deviceTypeLocal"
        @update-enabled="deviceEnabledLocal = $event"
        @update-value="deviceTypeLocal = $event"
      />

      <ActionSidebarSettingsTriggersItem
        type="url"
        :enabled="locationEnabledLocal"
        :value="locationValuesLocal"
        @update-enabled="locationEnabledLocal = $event"
        @update-value="locationValuesLocal = $event"
      >
        {{ $t('ActionSidebarSettingsTriggersUrl') }}
        <PWDropdown v-if="locationEnabledLocal">
          <template #default="{ toggle }">
            <span
              :class="$style.actionSidebarSettingsQueryText"
              @click="toggle()"
            >
              {{ ' ' + currentMatcherTitle }}
              <ArrowDropDownRounded :class="$style.actionSidebarSettingsQueryIcon" />
            </span>
          </template>
          <template #menu>
            <PWDropdownItem
              v-for="val in matcherValues"
              :key="val"
              @click="locationMatcherLocal = val"
            >
              {{ $t(includeValuesTitle[val]) }}
            </PWDropdownItem>
          </template>
        </PWDropdown>
      </ActionSidebarSettingsTriggersItem>
    </div>
  </PWAsideBodyItem>
</template>

<script>
/**
 * UI
 */
import PWAsideBodyItem from '@/components/_ui/Sidebars/PWAsideBodyItem.vue'
import ActionSidebarSettingsTriggersItem from '@/components/Actions/ActionSidebar/ActionSidebarSettingsTriggers/ActionSidebarSettingsTriggersItem.vue'
import PWDropdown from '@/components/_ui/Dropdowns/PWDropdown.vue'
import PWDropdownItem from '@/components/_ui/Dropdowns/PWDropdownItem.vue'
/**
 * Static
 */
import ArrowDropDownRounded from '@/assets/icons/ArrowDropDownRounded.svg?inline'

const INCLUDE_VALUES_TITLE = {
  includes: 'ActionSidebarSettingsTriggersIncludes',
  not_includes: 'ActionSidebarSettingsTriggersNotIncludes',
  equals: 'ActionSidebarSettingsTriggersEquals',
  not_equals: 'ActionSidebarSettingsTriggersNotEquals',
  starts_with: 'ActionSidebarSettingsTriggersStartsWith'
}

export default {
  components: {
    PWAsideBodyItem,
    ActionSidebarSettingsTriggersItem,
    PWDropdown,
    PWDropdownItem,
    ArrowDropDownRounded
  },
  props: {
    afterPageLoadEnabled: {
      type: Boolean,
      default: false
    },
    afterPageLoadSeconds: {
      type: Number,
      default: 30
    },
    pageScrollBelowEnabled: {
      type: Boolean,
      default: false
    },
    pageScrollBelowAmount: {
      type: Number,
      default: 30
    },
    deviceEnabled: {
      type: Boolean,
      default: false
    },
    deviceType: {
      type: String,
      default: 'desktop'
    },
    locationEnabled: {
      type: Boolean,
      default: false
    },
    locationMatcher: {
      type: String,
      default: 'includes'
    },
    locationValues: {
      type: Array,
      default: () => ([])
    }
  },
  data: () => ({
    matcherValues: [
      'includes',
      'not_includes',
      'equals',
      'not_equals',
      'starts_with'
    ],
    includeValuesTitle: INCLUDE_VALUES_TITLE
  }),
  computed: {
    currentMatcherTitle () {
      return this.$t(this.includeValuesTitle[this.locationMatcherLocal]).toLowerCase()
    },
    afterPageLoadEnabledLocal: {
      get () { return this.afterPageLoadEnabled },
      set (val) { this.$emit('update-afterPageLoadEnabled', val) }
    },
    afterPageLoadSecondsLocal: {
      get () { return this.afterPageLoadSeconds },
      set (val) { this.$emit('update-afterPageLoadSeconds', val) }
    },
    pageScrollBelowEnabledLocal: {
      get () { return this.pageScrollBelowEnabled },
      set (val) { this.$emit('update-pageScrollBelowEnabled', val) }
    },
    pageScrollBelowAmountLocal: {
      get () { return this.pageScrollBelowAmount },
      set (val) { this.$emit('update-pageScrollBelowAmount', val) }
    },
    deviceEnabledLocal: {
      get () { return this.deviceEnabled },
      set (val) { this.$emit('update-deviceEnabled', val) }
    },
    deviceTypeLocal: {
      get () { return this.deviceType },
      set (val) { this.$emit('update-deviceType', val) }
    },
    locationEnabledLocal: {
      get () { return this.locationEnabled },
      set (val) { this.$emit('update-locationEnabled', val) }
    },
    locationMatcherLocal: {
      get () { return this.locationMatcher },
      set (val) { this.$emit('update-locationMatcher', val) }
    },
    locationValuesLocal: {
      get () { return this.locationValues },
      set (val) { this.$emit('update-locationValues', val) }
    }
  }
}
</script>

<style module lang="scss">
@use '@/assets/scss/mixins';

.actionSidebarSettingsTriggers {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.actionSidebarSettingsTriggersField {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border-radius: 8px;
  background-color: var(--grey-100);
  padding: 16px 12px;
}

.actionSidebarSettingsQueryText {
  display: inline-flex;
  align-items: center;
  color: var(--main-blue);
  user-select: none;
  cursor: pointer;

  @include mixins.body2;
}

.actionSidebarSettingsQueryIcon {
  --s: 24px;

  width: 24px;
  height: 24px;
}
</style>
